export const panelPic = [{
  panelId: 90005,
  panelName: "日充放电量(kWh)",
  src: "../../../../static/images/boss/panelPic/90005日充放电量.png"
}, {
  panelId: 90006,
  panelName: "收益统计",
  src: "../../../../static/images/boss/panelPic/90006收益统计.png"
}, {
  panelId: 90007,
  panelName: "光伏统计",
  src: "../../../../static/images/boss/panelPic/90007光伏统计.png"
}, {
  panelId: 90008,
  panelName: "储能统计",
  src: "../../../../static/images/boss/panelPic/90008储能统计.png"
}, {
  panelId: 90009,
  panelName: "并网点功率曲线",
  src: "../../../../static/images/boss/panelPic/90009并网点功率曲线.png"
}, {
  panelId: 90010,
  panelName: "光伏统计",
  src: "../../../../static/images/boss/panelPic/90010光伏统计.png"
}, {
  panelId: 90011,
  panelName: "能耗统计",
  src: "../../../../static/images/boss/panelPic/90011能耗统计.png"
}, {
  panelId: 90012,
  panelName: "智能用能终端装机规模",
  src: "../../../../static/images/boss/panelPic/90012智能用终端装机规模.png"
}, {
  panelId: 90013,
  panelName: "智能用能终端装机规模",
  src: "../../../../static/images/boss/panelPic/90013智能用终端装机规模.png"
}, {
  panelId: 90014,
  panelName: "并网点数据",
  src: "../../../../static/images/boss/panelPic/90014并网点数据.png"
}, {
  panelId: 90015,
  panelName: "并网点数据",
  src: "../../../../static/images/boss/panelPic/90015并网点数据.png"
}, {
  panelId: 90016,
  panelName: "收益",
  src: "../../../../static/images/boss/panelPic/90016收益.png"
}, {
  panelId: 90017,
  panelName: "收益",
  src: "../../../../static/images/boss/panelPic/90017收益.png"
}, {
  panelId: 150002,
  panelName: "储能统计",
  src: "../../../../static/images/boss/panelPic/150002储能统计.png"
},
{
  panelId: 180002,
  panelName: "储能效率统计",
  src: "../../../../static/images/boss/panelPic/180002储能效率统计.png"
},
{
  panelId: 180003,
  panelName: "EP05",
  src: "../../../../static/images/boss/panelPic/ep05.png"
},
{
  panelId: 180004,
  panelName: "EP06",
  src: "../../../../static/images/boss/panelPic/ep06.png"
},
{
  panelId: 180005,
  panelName: "单元柜",
  src: "../../../../static/images/boss/panelPic/danyuangui.png"
},
{
  panelId: 180006,
  panelName: "集装箱",
  src: "../../../../static/images/boss/panelPic/jizhuangxiang.png"
},
{
  panelId: 180007,
  panelName: "梯次储能",
  src: "../../../../static/images/boss/panelPic/danyuangui.png"
}
]



// WEBPACK FOOTER //
// ./src/views/boss/project/panelPic.js